import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=28a6d385&scoped=true"
import script from "./SearchFilter.vue?vue&type=script&lang=js"
export * from "./SearchFilter.vue?vue&type=script&lang=js"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=28a6d385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6d385",
  null
  
)

export default component.exports